import {
  SET_GC_PHASE,
  SET_GC_FIELD,
  SET_GC_FORM,
  SET_GC_LOADING,
  SET_GC_ERROR,
  SET_GC_ACTIVATION,
  RESET_GC,
} from "./mutation-types";

import service from "@/service";
import config from "@/config";
import axios from "axios";

const $service = service(axios, config);

export default {
  // ── Mettre à jour un champ ──
  applyGcSetField({ commit }, { key, value }) {
    commit(SET_GC_FIELD, { key, value });
  },

  applyGcSetForm({ commit }, partial) {
    commit(SET_GC_FORM, partial);
  },

  // ── Changer de phase ──
  applyGcSetPhase({ commit }, phase) {
    commit(SET_GC_PHASE, phase);
  },

  // ── Soumettre l'activation ──
  async applyGcSubmitActivation({ commit, state }) {
    commit(SET_GC_LOADING, { key: "submit", value: true });
    commit(SET_GC_ERROR, { key: "submit", message: "" });

    const f = state.form;
    const phone = `${f.phoneDial} ${f.phoneNumber.trim()}`;
    const whatsappNumber = f.sameAsWhatsapp
      ? phone
      : `${f.waDial} ${f.waNumber.trim()}`;

    const payload = {
      civility: f.civility,
      firstName: f.firstName.trim(),
      lastName: f.lastName.trim(),
      phone,
      whatsappNumber,
      eventCode: f.eventCode || "default",
      hasAutoInsurance: f.hasAuto,
      autoInsuranceExpiry: f.hasAuto ? f.autoExpiryDate : null,
      hasHomeInsurance: f.hasHome,
      homeInsuranceExpiry: f.hasHome ? f.homeExpiryDate : null,
    };

    const result = await $service
      .submitGiftCardActivation(payload)
      .then((res) => ({ data: res.data, status: res.status }))
      .catch((error) => {
        const msg = error.response?.data?.message;
        const friendly =
          error.response?.status === 409
            ? "Cette carte a déjà été activée pour ce numéro."
            : Array.isArray(msg)
            ? msg[0]
            : msg || "Une erreur est survenue. Réessayez.";
        return { msg: friendly, status: error.response?.status || 500 };
      });

    commit(SET_GC_LOADING, { key: "submit", value: false });

    if (result.status === 200 || result.status === 201) {
      commit(SET_GC_ACTIVATION, result.data);
      commit(SET_GC_PHASE, "success");
      return result;
    }

    commit(SET_GC_ERROR, { key: "submit", message: result.msg });
    return { ...result, status: 400 };
  },

  // ── Réinitialiser ──
  applyGcReset({ commit }) {
    commit(RESET_GC);
  },
};
